import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import MobilePortraitPage from "../components/MobilePortraitPage";
import MobileLandscapePage from "../components/MobileLandscapePage";

const getDeviceType = () => {
  const ua = navigator.userAgent;

  if (/Mobi|Android|iPhone/i.test(ua)) {
    return "mobile"; // Detects mobile devices
  } else if (/Tablet|iPad/i.test(ua)) {
    return "tablet"; // Detects tablets
  } else {
    return "desktop"; // Otherwise, it's a desktop/laptop
  }
};

const getOrientation = () => {
  return window.innerWidth > window.innerHeight ? "landscape" : "portrait";
};

const UserLayout = () => {
  const deviceType = getDeviceType(); // Use as a simple variable, not state
  const [orientation, setOrientation] = useState(getOrientation());

  useEffect(() => {
    const handleResize = () => {
      setOrientation(getOrientation());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (deviceType === "desktop") {
    return <Outlet />;
  } else {
    return orientation === "portrait" ? <MobilePortraitPage /> : <MobileLandscapePage />;
  }
};

export default UserLayout;
